module.exports = __webpack_public_path__ + "static/media/image8.ec2543c8.JPG";